
<template>
  <div class="maps">
    <h1 class="teal--text text--darken-4">Voyages <i class="fas fa-globe-americas"></i></h1>
    <v-carousel v-model="activeMap" height="800">
        <v-carousel-item v-for="item in items" :key="item.key">
            <v-card class="transparent">
                <v-toolbar-title class="black--text">{{ item.label }}</v-toolbar-title>
                <v-responsive :aspect-ratio="16/9">
                    <iframe :src="item.url" width="1024" height="720"></iframe>
                </v-responsive>
            </v-card>
        </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
    name: 'Maps',
    components: {
    },
    data: () => ({
        activeMap: 'seen',
        items: [
            { key:'seen', label:'Déjà visité', url:'https://www.google.fr/maps/d/embed?mid=1Vh8u5fUC7vue628HuGH2AfezeN_BKJjE&z=3' },
            { key:'wishes', label:'Je souhaite voir', url:'https://www.google.fr/maps/d/embed?mid=13Hfnj-LL83pa0O8nBrZqPMlcubs&z=2&ll=30.113184306673286%2C30.322263625000005' },
        ]
    }),
}
</script>
